import { render } from "./iconHome.vue?vue&type=template&id=089110a5"
import script from "./iconHome.vue?vue&type=script&lang=js"
export * from "./iconHome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__